import CoreStoreModule from './CoreStoreModule'
import { OnboardingApp } from './OnboardingStoreModule'

export default class OnboardingStoreModuleContainer {
  coreStoreModule: CoreStoreModule
  appName: OnboardingApp

  constructor (coreStoreModule: CoreStoreModule, appName: OnboardingApp) {
    this.coreStoreModule = coreStoreModule
    this.appName = appName
  }
}
